import { StringHelpers } from "../../../helpers/string-helpers";
import { IComponent } from "../../component.interface";
import { IDrawingTool } from "../drawing-tool.interface";
import { DrawingToolsManager } from "../drawing-tools.manager";

export class EmojiComponent implements IComponent, IDrawingTool {
    public static validEmojiRegex = /[\u{1F300}-\u{1F64F}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F1E6}-\u{1F1FF}\u{1F191}-\u{1F251}\u{1F600}-\u{1F636}\u{1F681}-\u{1F6C5}\u{1F30D}-\u{1F567}]+/u;

    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    private xAxis = 0;
    private yAxis = 0;

    constructor(drawingToolManager: DrawingToolsManager, id: string, annotation: any) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
        this.annotation = annotation;

        this.xAxis = this.annotation.options.typeOptions.point.xAxis;
        this.yAxis = this.annotation.options.typeOptions.point.yAxis;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): EmojiComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;
        const builder = drawingToolManager.base.tiChartSeries.highChartBuilder;
        const series = drawingToolManager.base.tiChartSeries;

        let xAxis = 0;
        let yAxis = 0;

        if (!annotationOptions.events) {
            annotationOptions.events = {};
        }

        if (annotationOptions.typeOptions?.point) {
            xAxis = annotationOptions.typeOptions.point.xAxis;
            yAxis = annotationOptions.typeOptions.point.yAxis;
        }

        annotationOptions.events.afterUpdate = function (event) {
            console.log('emoji afterUpdate ', event)

            if (event.target?.userOptions?.typeOptions?.point && event.target?.options?.typeOptions?.point) {
                event.target.userOptions.typeOptions.point.x = event.target.options.typeOptions.point.x;
                event.target.userOptions.typeOptions.point.y = event.target.options.typeOptions.point.y;
            }

            drawingToolManager.updateAnnotationStyles(event.target, annotationOptions, true);
            const afterDrawingToolCompleted = event && event.target && !event.target.isUpdating;
            if (afterDrawingToolCompleted) {
                console.log('afterDrawingToolCompleted sync created')
                drawingToolManager.saveAnnotations();
            }
            builder.drawingToolRibbonUpdate(() => {
                series.onAnnotationAfterUpdate(event);
            });

            setTimeout(() => {
                component.setAnnotationPosition();
            }, 250);
        };

        let prevX, prevY;
        annotationOptions.events.drag = function (event) {
            const bbox = this.graphic.element.getBBox();
            if (!bbox) {
                return;
            }

            const textBBox = this.graphic.element.querySelector('text').getBBox();
            if (!textBBox) {
                return;
            }

            if (!prevX) {
                prevX = event.chartX;
            }

            if (!prevY) {
                prevY = event.chartY;
            }

            const xDirection = event.chartX > prevX ? 'right' : event.chartX < prevX ? 'left' : 'none';
            const yDirection = event.chartY > prevY ? 'bottom' : event.chartY < prevY ? 'top' : 'none';


            prevX = event.chartX;
            prevY = event.chartY;

            // const chartX = event.chartX;
            // const boxHeight = bbox.height;

            let shouldUpdate = false;

            const textBBoxWidth = textBBox.width;
            const textBBoxHeight = textBBox.height;

            const boxWidth = bbox.width;
            const bboxChartXRight = bbox.x + boxWidth;
            const bboxChartXLeft = bbox.x;

            const bboxChartYTop = bbox.y;
            const bboxChartYBottom = bbox.y + bbox.height;

            const yAxisHeight = chart.yAxis[xAxis].height;
            const yAxisTop = chart.yAxis[yAxis].top;

            console.log('drag, ', chart, bbox)
            console.log('drag x, ', xDirection)
            console.log('drag y, ', yDirection)


            const chartTopThreshold = 60;
            const chartLeftThreshold = 80;
            const chartRightThreshold = 60;

            console.log('Direction bbox ', bbox)

            if (xDirection == 'right' && bboxChartXRight > chart.plotSizeX + (chartRightThreshold / 2)) {
                console.log(`xDirection == 'right' && event.chartX > chart.plotSizeX`, bboxChartXRight, chart.plotSizeX + (chartRightThreshold / 2));

                let x = 0;

                if (textBBoxWidth > 60) {
                    x = chart.xAxis[xAxis].toValue((chart.plotSizeX + chartRightThreshold) - (textBBoxWidth * 0.6));
                } else {
                    x = chart.xAxis[xAxis].toValue(chart.plotSizeX + (chartRightThreshold / 2.5));
                }

                console.log('xDirection right x', x)

                this.options.typeOptions.point.x = x;
                shouldUpdate = true;
            } else if (xDirection == 'left' && bboxChartXLeft < chartLeftThreshold) {
                console.log(`xDirection == 'left' && bboxChartXLeft < 80`, bboxChartXLeft);
                let x = chart.xAxis[xAxis].toValue(80);

                console.log('xDirection left x', x)
                this.options.typeOptions.point.x = x;
                shouldUpdate = true;
            }

            if (yAxis == 0) {
                if (yDirection == 'bottom' && bboxChartYBottom > yAxisHeight) {
                    console.log(`yDirection == 'bottom' && bboxChartYBottom >  yAxisHeight`, bboxChartYBottom, yAxisHeight);

                    let y = 0;
                    if (textBBoxHeight > 50) {
                        y = chart.yAxis[yAxis].toValue(yAxisHeight - (textBBoxHeight * 0.6));
                    } else {
                        y = chart.yAxis[yAxis].toValue(yAxisHeight + 5);
                    }

                    console.log('yDirection bottom y', y)
                    this.options.typeOptions.point.y = y;
                    shouldUpdate = true;
                } else if (yDirection == 'top' && bboxChartYTop < chartTopThreshold + 20) {
                    console.log(`yDirection == 'top' && bboxChartXTop < 50`);
                    let y = 0;
                    if (textBBoxHeight > 50) {
                        y = chart.yAxis[yAxis].toValue(chartTopThreshold + 25);
                    } else {
                        y = chart.yAxis[yAxis].toValue(chartTopThreshold);
                    }

                    console.log('yDirection top y', y)
                    this.options.typeOptions.point.y = y;
                    shouldUpdate = true;
                }
            } else {
                const indicatorChartYTop = bboxChartYTop - yAxisTop;
                const indicatorChartYBottom = bboxChartYBottom - yAxisTop;
                const indicatorChartTopThreshold = 10;
                if (yDirection == 'bottom' && indicatorChartYBottom > yAxisHeight) {
                    console.log(`yDirection == 'bottom' && indicatorChartYBottom >  yAxisHeight`, indicatorChartYBottom, yAxisHeight);

                    let y = chart.yAxis[yAxis].toValue(yAxisTop + yAxisHeight - textBBoxHeight);

                    console.log('yDirection bottom y', y)
                    this.options.typeOptions.point.y = y;
                    shouldUpdate = true;
                } else if (yDirection == 'top' && indicatorChartYTop < indicatorChartTopThreshold) {
                    console.log(`yDirection == 'top' && indicatorChartYTop < yAxisTop - indicatorChartTopThreshold`, indicatorChartYTop, yAxisTop, indicatorChartTopThreshold);

                    let y = chart.yAxis[yAxis].toValue(yAxisTop + indicatorChartTopThreshold);

                    console.log('yDirection top y', y)
                    this.options.typeOptions.point.y = y;
                    shouldUpdate = true;
                }
            }


            if (shouldUpdate) {
                drawingToolManager.updateAnnotationStyles(this, this.options, true);
                drawingToolManager.saveAnnotations();
            }
        };

        annotationOptions.events.add = function () {
            drawingToolManager.removeRootDrawMode(false);
            chart.navigationBindings.deselectAnnotation();

            setTimeout(() => {
                drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, true);
            }, 500);
        };

        if (annotationOptions.typeOptions?.point?.startTimeT > 0) {
            const actualDataPoint = drawingToolManager.base.tiChartSeries.tiChartPoints.find(x => x.startTimeT == annotationOptions.typeOptions.point.startTimeT);

            if (actualDataPoint) {
                // const origialX = annotationOptions.typeOptions.point.originalX;
                // const decimalPart = origialX - Math.floor(origialX);

                annotationOptions.typeOptions.point.x = actualDataPoint.xValue;
            }

            console.log('EMOJI: event ', event, ' x ', annotationOptions.typeOptions.point.x, ' y ', annotationOptions.typeOptions.point.y)

            console.log('EMOJI: eactualDataPointvent ', actualDataPoint)

        }

        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);
        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, true);

        const component = new EmojiComponent(drawingToolManager, annotationOptions.id, addedNewAnnotation);
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any, emoji: string, emojiCreateType: number): EmojiComponent {
        const id = StringHelpers.newGuid();
        const series = drawingToolManager.base.tiChartSeries;
        const builder = drawingToolManager.base.tiChartSeries.highChartBuilder;
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;

        const coords = chart.pointer.getCoordinates(event)
        const coordsX = chart.navigationBindings.utils.getAssignedAxis(coords.xAxis)
        const coordsY = chart.navigationBindings.utils.getAssignedAxis(coords.yAxis)

        const defaultFontSize = drawingToolManager.base.tiChartSeries.chartStyleSettings.emojiDefaultSize;
        const fontSizeInPx = defaultFontSize > 0 ? defaultFontSize + 'px' : '24px';

        const chartX = event.chartX;
        const chartY = event.chartY;
        const x = chart.xAxis[coordsX.axis.options.index].toValue(chartX);
        const y = chart.yAxis[coordsY.axis.options.index].toValue(chartY);


        console.log('EMOJI: event ', event, ' x ', x, ' y ', y)

        const actualDataPoint = drawingToolManager.base.tiChartSeries.tiChartPoints.find(p => p.xValue + '' == x.toFixed(0));


        console.log('EMOJI: actualDataPointvent ', actualDataPoint)

        // const width = 5; // Width
        // const height = 5; // Height
        // const fillColor = 'rgba(255, 0, 0, 0.5)'; // Fill color

        // chart.renderer.rect(chartX, chartY, width, height)
        // .attr({
        //     'stroke-width': 2, // Border width
        //     stroke: 'green', // Border color
        //     fill: fillColor // Fill color
        // })
        // .add();

        let prevX, prevY;
        const options = {
            langKey: "verticalLabel",
            type: 'verticalLine',
            isEmoji: true,
            emojiCreateType: emojiCreateType,

            zIndex: 20,
            labelOptions: {
                text: " ",
                crop: false,
                overflow: 'none',
                style: {
                    color: "#666666" /* Palette.neutralColor60 */,
                    fontSize: fontSizeInPx
                }
            },
            typeOptions: {
                point: {
                    xAxis: coordsX.axis.options.index,
                    yAxis: coordsY.axis.options.index,
                    x: actualDataPoint?.xValue ?? x,
                    y: y,

                    startTimeT: actualDataPoint?.startTimeT ?? null,
                    // originalX: x,
                },
                label: {
                    offset: 0,
                    text: emoji,
                    //     x: 0,
                    //     y: 0,
                    crop: false,
                    overflow: 'none',

                    // style: {
                    //     fontSize: fontSizeInPx
                    // }
                },
                connector: {
                    stroke: emoji,
                    fill: 'transparent'
                }
            },
            shapeOptions: {
                stroke: 'rgba(0, 0, 0, 0.75)',
                strokeWidth: 1
            },
            events: {
                drag: function (event) {
                    const bbox = this.graphic.element.getBBox();
                    if (!bbox) {
                        return;
                    }

                    const textBBox = this.graphic.element.querySelector('text').getBBox();
                    if (!textBBox) {
                        return;
                    }

                    if (!prevX) {
                        prevX = event.chartX;
                    }

                    if (!prevY) {
                        prevY = event.chartY;
                    }

                    const xDirection = event.chartX > prevX ? 'right' : event.chartX < prevX ? 'left' : 'none';
                    const yDirection = event.chartY > prevY ? 'bottom' : event.chartY < prevY ? 'top' : 'none';


                    prevX = event.chartX;
                    prevY = event.chartY;

                    // const chartX = event.chartX;
                    // const boxHeight = bbox.height;

                    let shouldUpdate = false;

                    const textBBoxWidth = textBBox.width;
                    const textBBoxHeight = textBBox.height;

                    const boxWidth = bbox.width;
                    const bboxChartXRight = bbox.x + boxWidth;
                    const bboxChartXLeft = bbox.x;

                    const bboxChartYTop = bbox.y;
                    const bboxChartYBottom = bbox.y + bbox.height;

                    const yAxisHeight = chart.yAxis[coordsY.axis.options.index].height;
                    const yAxisTop = chart.yAxis[coordsY.axis.options.index].top;

                    console.log('drag, ', chart, bbox)
                    console.log('drag x, ', xDirection)
                    console.log('drag y, ', yDirection)


                    const chartTopThreshold = 60;
                    const chartLeftThreshold = 80;
                    const chartRightThreshold = 60;

                    console.log('Direction bbox ', bbox)

                    if (xDirection == 'right' && bboxChartXRight > chart.plotSizeX + (chartRightThreshold / 2)) {
                        console.log(`xDirection == 'right' && event.chartX > chart.plotSizeX`, bboxChartXRight, chart.plotSizeX + (chartRightThreshold / 2));

                        let x = 0;

                        if (textBBoxWidth > 60) {
                            x = chart.xAxis[coordsX.axis.options.index].toValue((chart.plotSizeX + chartRightThreshold) - (textBBoxWidth * 0.6));
                        } else {
                            x = chart.xAxis[coordsX.axis.options.index].toValue(chart.plotSizeX + (chartRightThreshold / 2.5));
                        }

                        console.log('xDirection right x', x)

                        this.options.typeOptions.point.x = x;
                        shouldUpdate = true;
                    } else if (xDirection == 'left' && bboxChartXLeft < chartLeftThreshold) {
                        console.log(`xDirection == 'left' && bboxChartXLeft < 80`, bboxChartXLeft);
                        let x = chart.xAxis[coordsX.axis.options.index].toValue(80);

                        console.log('xDirection left x', x)
                        this.options.typeOptions.point.x = x;
                        shouldUpdate = true;
                    }

                    if (coordsY.axis.options.index == 0) {
                        if (yDirection == 'bottom' && bboxChartYBottom > yAxisHeight) {
                            console.log(`yDirection == 'bottom' && bboxChartYBottom >  yAxisHeight`, bboxChartYBottom, yAxisHeight);

                            let y = 0;
                            if (textBBoxHeight > 50) {
                                y = chart.yAxis[coordsY.axis.options.index].toValue(yAxisHeight - (textBBoxHeight * 0.6));
                            } else {
                                y = chart.yAxis[coordsY.axis.options.index].toValue(yAxisHeight + 5);
                            }

                            console.log('yDirection bottom y', y)
                            this.options.typeOptions.point.y = y;
                            shouldUpdate = true;
                        } else if (yDirection == 'top' && bboxChartYTop < chartTopThreshold + 20) {
                            console.log(`yDirection == 'top' && bboxChartXTop < 50`);

                            let y = 0;
                            if (textBBoxHeight > 50) {
                                y = chart.yAxis[coordsY.axis.options.index].toValue(chartTopThreshold + 25);
                            } else {
                                y = chart.yAxis[coordsY.axis.options.index].toValue(chartTopThreshold);
                            }
                            
                            console.log('yDirection top y', y)
                            this.options.typeOptions.point.y = y;
                            shouldUpdate = true;
                        }
                    } else {
                        const indicatorChartYTop = bboxChartYTop - yAxisTop;
                        const indicatorChartYBottom = bboxChartYBottom - yAxisTop;
                        const indicatorChartTopThreshold = 10;
                        if (yDirection == 'bottom' && indicatorChartYBottom > yAxisHeight) {
                            console.log(`yDirection == 'bottom' && indicatorChartYBottom >  yAxisHeight`, indicatorChartYBottom, yAxisHeight);

                            let y = chart.yAxis[coordsY.axis.options.index].toValue(yAxisTop + yAxisHeight - textBBoxHeight);

                            console.log('yDirection bottom y', y)
                            this.options.typeOptions.point.y = y;
                            shouldUpdate = true;
                        } else if (yDirection == 'top' && indicatorChartYTop < indicatorChartTopThreshold) {
                            console.log(`yDirection == 'top' && indicatorChartYTop < yAxisTop - indicatorChartTopThreshold`, indicatorChartYTop, yAxisTop, indicatorChartTopThreshold);

                            let y = chart.yAxis[coordsY.axis.options.index].toValue(yAxisTop + indicatorChartTopThreshold);

                            console.log('yDirection top y', y)
                            this.options.typeOptions.point.y = y;
                            shouldUpdate = true;
                        }
                    }


                    if (shouldUpdate) {
                        drawingToolManager.updateAnnotationStyles(this, this.options, true);
                        drawingToolManager.saveAnnotations();
                    }
                },

                add: function (event) {
                    if (event.target?.options) {
                        event.target.options.id = id;
                    }

                    drawingToolManager.removeRootDrawMode(false);
                    chart.navigationBindings.deselectAnnotation();
                    if (chart.navigationBindings.popup) {
                        const closeButton = chart.navigationBindings.popup.container?.querySelector('.highcharts-popup-close');
                        closeButton?.click();
                        chart.navigationBindings.popup.closePopup();
                    }

                    series.onAnnotationAdd(event, false);
                },
                afterUpdate: function (event) {
                    console.log('emoji afterUpdate ', event)
                    if (event.target?.options && !event.target.options.id) {
                        event.target.options.id = id;
                    }

                    if (event.target?.userOptions?.typeOptions?.point && event.target?.options?.typeOptions?.point) {
                        event.target.userOptions.typeOptions.point.x = event.target.options.typeOptions.point.x;
                        event.target.userOptions.typeOptions.point.y = event.target.options.typeOptions.point.y;
                    }

                    drawingToolManager.updateAnnotationStyles(event.target, annotation, true);

                    const afterDrawingToolCompleted = event && event.target && !event.target.isUpdating;
                    if (afterDrawingToolCompleted) {
                        drawingToolManager.saveAnnotations();
                    }
                    builder.drawingToolRibbonUpdate(() => {
                        series.onAnnotationAfterUpdate(event);
                    });

                    setTimeout(() => {
                        component.setAnnotationPosition();
                    }, 250);
                },
                remove: function () {
                    drawingToolManager.delete();
                }
            }
        };

        const annotation = chart.addAnnotation(options);

        const component = new EmojiComponent(drawingToolManager, id, annotation);
        drawingToolManager.updateAnnotationStyles(annotation, options, true);
        return component;
    }

    public getMetaData(): any {
        const stroke = this.annotation.options.typeOptions?.connector?.stroke?.trim() ?? '';
        if (!stroke || !EmojiComponent.validEmojiRegex.test(stroke)) {
            return null;
        }

        const x = this.annotation.options.typeOptions.point.x;
        const actualDataPoint = this.drawingToolManager.base.tiChartSeries.tiChartPoints.find(p => p.xValue + '' == x.toFixed(0));
        return {
            id: this.id,
            langKey: "verticalLabel",
            type: 'verticalLine',
            isEmoji: true,
            emojiCreateType: this.annotation.options.emojiCreateType,

            zIndex: 20,
            labelOptions: {
                text: this.annotation.options.labelOptions.text,
                // format: stroke,
                // allowOverlap: true,
                // backgroundColor: this.annotation.options.labelOptions.backgroundColor,

                crop: false,
                overflow: 'none',

                // verticalAlign: 'middle',
                // //align: 'left',
                // x: 0,
                // y: 0,

                style: {
                    // color: this.annotation.options.labelOptions.style.color,
                    fontSize: this.annotation.options.typeOptions.label.style.fontSize
                }
            },
            typeOptions: {
                point: {
                    xAxis: this.annotation.options.typeOptions.point.xAxis,
                    yAxis: this.annotation.options.typeOptions.point.yAxis,
                    x: this.annotation.options.typeOptions.point.x,
                    y: this.annotation.options.typeOptions.point.y,

                    startTimeT: actualDataPoint?.startTimeT ?? null,
                    // actualDataPointX: actualDataPoint?.xValue ?? null,
                    // originalX: x,
                },
                label: {
                    offset: 0,
                    text: stroke,
                    // x: 0,
                    // y: 0,

                    crop: false,
                    overflow: 'none',

                    // style: {
                    //     fontSize: this.annotation.options.typeOptions.label.style.fontSize
                    // }
                },
                connector: {
                    stroke: stroke,
                    fill: 'transparent'
                }
            },
            shapeOptions: {
                stroke: 'rgba(0, 0, 0, 0.75)',
                strokeWidth: 1
            }
        };
    }

    private resizerActive = false;
    public setComponentResizer(remove: boolean) {
        let isResizing = false;
        let useDeltaX = false;
        let shouldSubstract = false;
        let startX = 0;
        let startY = 0;
        let startFontSize = 0;

        const highChartRoot = this.drawingToolManager.base.tiChartSeries.element.querySelector<HTMLElement>('.highcharts-root');
        const text = this.annotation?.graphic?.element?.querySelector('.highcharts-annotation-labels text');
        if (!text || !highChartRoot) {
            return;
        }

        const annotationLabelsElement = this.annotation?.graphic?.element?.querySelector('.highcharts-annotation-labels');
        const chart: any = this.drawingToolManager.base.tiChartSeries.highStockChart;
        let newFontSize = 0;
        let resizeTimer: any;
        const resize = (e) => {
            if (!isResizing) return;

            const deltaX = (startX - e.clientX) * 0.65;
            const deltaY = (startY - e.clientY) * 0.65;

            console.log('deltaX ', deltaX, 'deltaY ', deltaY)
            // Calculate the new width and height while maintaining the aspect ratio
            if (useDeltaX) {
                newFontSize = Math.floor(startFontSize + (deltaX * (shouldSubstract ? -1 : 1)));
            } else {
                newFontSize = Math.floor(startFontSize + (deltaY * (shouldSubstract ? -1 : 1)));
            }

            if (newFontSize < 14) {
                newFontSize = 14;
            } else if (newFontSize > 350) {
                newFontSize = 350;
            }

            let text = this.annotation?.graphic?.element?.querySelector('.highcharts-annotation-labels text');
            text?.setAttribute('style', `font-size: ${newFontSize}px; fill: rgb(0, 0, 0);`);
        }

        const stopResize = (e) => {
            isResizing = false;

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {

                console.log('stopResize 1', this.annotation.userOptions.typeOptions.point.x, this.annotation.userOptions.typeOptions.point.y);
                let text = this.annotation?.graphic?.element?.querySelector('.highcharts-annotation-labels text');
                if (!text) {
                    return;
                }

                const clientRect = text.getBoundingClientRect();
                console.log('stopResize 2', clientRect);
                const left = Math.round(clientRect.left + 60);
                const realX = Math.round(chart.xAxis[this.xAxis].toValue(left));
                const x = Math.round(chart.xAxis[this.xAxis].toValue(left + (clientRect.width / 2)));
                const y = chart.yAxis[this.yAxis].toValue(clientRect.top);

                console.log('stopResize 3', x, y, 'real x ', realX);

                // const width = 5; // Width
                // const height = 5; // Height
                // const fillColor = 'rgba(255, 0, 0, 0.5)'; // Fill color

                // console.log('stopResize 4 ', left, clientRect.top)
                // chart.renderer.rect(left, clientRect.top, width, height)
                // .attr({
                //     'stroke-width': 2, // Border width
                //     stroke: 'red', // Border color
                //     fill: fillColor // Fill color
                // })
                // .add();

                this.annotation.update({
                    labelOptions: {
                        style: {
                            fontSize: newFontSize + 'px'
                        }
                    },
                    typeOptions: {
                        label: {
                            style: {
                                fontSize: newFontSize + 'px'
                            }
                        }
                    }
                });

                const annotationLabelsElement = this.annotation?.graphic?.element?.querySelector('.highcharts-annotation-labels');
                annotationLabelsElement.classList.remove('dragging-horizontal');
                annotationLabelsElement.classList.remove('dragging-vertical');
                highChartRoot.removeAttribute('style')
                annotationLabelsElement.classList.add('active');

                this.drawingToolManager.updateAnnotationStyles(this.annotation, this.annotation.options, true);

                this.drawingToolManager.saveAnnotations();

                addResizerLines();

            }, 200);

            document.removeEventListener('mousemove', resize);
            document.removeEventListener('mouseup', stopResize);
        }

        console.log('add resizer')

        const removeResizerLines = () => {
            console.log('removeResizerLines')

            annotationLabelsElement.classList.remove('active');
            document.body.querySelectorAll('.emoji-resize').forEach(control => {
                control.remove();
            });

            document.removeEventListener('mousemove', resize);
            document.removeEventListener('mouseup', stopResize);

        }

        const addResizerLines = () => {
            removeResizerLines();

            console.log('addResizerLines')
            annotationLabelsElement.classList.add('active');

            const div = document.createElement('DIV');
            div.className = 'emoji-resize';

            div.innerHTML = `
            <div class="horizontal emoji-resize-control"></div>
            <div class="horizontal substract emoji-resize-control"></div>
            <div class="vertical emoji-resize-control"></div>
            <div class="vertical substract emoji-resize-control"></div>`;

            this.drawingToolManager.base.tiChartSeries.element.querySelector('.main-chart')?.insertAdjacentElement('beforeend', div)

            setTimeout(() => {
                this.setAnnotationPosition();
                div.querySelectorAll<HTMLElement>('.emoji-resize-control').forEach(control => {
                    control.addEventListener('mousedown', (e) => {
                        e.preventDefault();
                        isResizing = true;
                        startX = e.clientX;
                        startY = e.clientY;

                        startFontSize = parseFloat(this.annotation.options.typeOptions.label.style.fontSize.replace('px', ''));
                        if (control.classList.contains('horizontal')) {
                            useDeltaX = false;
                            annotationLabelsElement.classList.add('dragging-horizontal');
                            highChartRoot.setAttribute('style', 'cursor: n-resize !important');
                        } else {
                            useDeltaX = true;
                            annotationLabelsElement.classList.add('dragging-vertical');
                            highChartRoot.setAttribute('style', 'cursor: e-resize !important');
                        }

                        shouldSubstract = false;
                        if (control.classList.contains('substract')) {
                            shouldSubstract = true;
                        }

                        console.log('control mouse down', control)
                        document.addEventListener('mousemove', resize);
                        document.addEventListener('mouseup', stopResize);
                    });
                });
            }, 300);
        };

        if (remove) {
            this.resizerActive = false;
            removeResizerLines();
            setTimeout(() => {
                this.drawingToolManager.updateAnnotationStyles(this.annotation, this.annotation.options, true);
            }, 300);
        } else {
            this.resizerActive = true;
            addResizerLines();
        }
    }

    private setAnnotationPosition() {
        if (!this.resizerActive) {
            return;
        }

        const emojiResizer = document.querySelector<HTMLElement>('.emoji-resize');
        if (!emojiResizer) {
            return;
        }

        const bbox = this.annotation.graphic.element.getBBox();
        const textBBox = this.annotation.graphic.element.querySelector('text')?.getBBox();
        if (!textBBox) {
            return;
        }

        emojiResizer.style.top = bbox.y + 'px';
        emojiResizer.style.left = (bbox.x - 60) + 'px';

        emojiResizer.querySelectorAll<HTMLElement>('.emoji-resize-control').forEach((el: HTMLElement) => {
            if (el.classList.contains('horizontal')) {
                el.style.width = textBBox.width + 'px';
                if (el.classList.contains('substract')) {
                    el.style.top = (textBBox.height + 5) + 'px';
                }
            } else if (el.classList.contains('vertical')) {
                el.style.height = textBBox.height + 'px';
                if (el.classList.contains('substract')) {
                    el.style.left = (textBBox.width + 5) + 'px';
                }
            }
        });
    }
}